import { render, staticRenderFns } from "./ReportLayoutForm.vue?vue&type=template&id=3b2e22a1&scoped=true"
import script from "./ReportLayoutForm.vue?vue&type=script&lang=js"
export * from "./ReportLayoutForm.vue?vue&type=script&lang=js"
import style0 from "./ReportLayoutForm.vue?vue&type=style&index=0&id=3b2e22a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e22a1",
  null
  
)

export default component.exports